import React from "react"
import Wrapper from "components/layout/wrapper"
import { Box, Flex, Grid, GridItem, Heading, Link, useMediaQuery, Text } from "@chakra-ui/react"
import { CalendarIcon } from "components/graphics/calendarIcon"

export default function TctAfrica2027Deadlines({ block }) {
    const { parameters, customClass } = block;
    const headerTitle = parameters[0]?.value;
    const subTitle = parameters[1]?.value;
    const descText = parameters[2]?.value;
    const [mobile] = useMediaQuery("(max-width: 1065px)")

    // const headerStyles = {
    //     fontSize: "42px !important",
    //     lineHeight: "46px !important",
    // }
    const jsonObj = block?.json ? JSON.parse(block.json) : []
    const dateList = jsonObj

    return (
        <Grid
            width={"100%"}
            templateColumns={`1fr 1fr 1fr`}
            templateRows={`1fr`}
            background={"#423060"}
            className={`${customClass ? customClass : ""}`}
        >
            <GridItem
                zIndex={"10"}
                gridColumnStart={1}
                gridColumnEnd={4}
                gridRowStart={1}
                gridRowEnd={2}
                padding={"30px 0px"}
            >
                <Wrapper>
                    <Heading
                        textAlign={"center"}
                        mt={"0px"}
                        mb={mobile ? "10px" : "30px!important"}
                        color={"white !important"}
                        // {...headerStyles}
                        fontSize={mobile ? "28px!important" : "42px !important"}
                        lineHeight={mobile ? "32px!important" : "46px !important"}
                    >
                        <Box
                            as={"span"}
                            css={{
                                "& a": {
                                    textDecoration: "underline !important",
                                },
                            }}
                        >
                            {headerTitle}
                        </Box>
                        {!mobile && <span>&nbsp;{subTitle}</span>}
                    </Heading>
                    {mobile && (
                        <Box
                            textAlign={"center"}
                            mb={"20px"}
                            fontWeight={600}
                            fontSize={"22px!important"}
                            lineHeight={"26px!important"}
                        >
                            {subTitle}
                        </Box>
                    )}
                    <Flex
                        gap={mobile ? "20px" : "40px"}
                        flexDirection={mobile ? "column" : "row"}
                        alignItems={mobile ? "center" : "normal"}
                        flexWrap={mobile ? "wrap" : "nowrap"}
                        className={`${customClass ? customClass + "-wrapper" : ""}`}
                    >
                        {dateList.map((d, i) => {
                            const title = d.title
                            const addEvent = d.addevent
                            const dateLabel = d.date
                            const timeLabel = d.time
                            const closedText = d?.closed ? true : false
                            return (
                                <Box
                                    key={i}
                                    backgroundColor={"white"}
                                    borderRadius={"40px"}
                                    display={"flex"}
                                    flexDirection={"column"}
                                    justifyContent={"space-evenly"}
                                    padding={mobile ? "20px 20px" : "20px 5px"}
                                    gap={"5px"}
                                    alignItems={"center"}
                                    //flex={mobile ? "1 1 50%" : "none"}
                                    flexGrow={mobile ? 1 : 1}
                                    flexShrink={mobile ? 1 : 1}
                                    flexBasis={mobile ? "100%" : "0"}
                                    width={mobile ? "100%" : "auto"}
                                    maxW={mobile ? "375px" : "none"}
                                    border={"solid 4px #EFF2F5"}
                                    minHeight={"230px"}
                                >
                                    {mobile && customClass !== "key-dates" ? (
                                        <>
                                            <Flex alignItems={"anchor-center"} width={"100%"}>
                                                <Box flexGrow={"1"}>
                                                    <Heading
                                                        mt={"0px"}
                                                        textAlign={"left"}
                                                        fontSize={"16px !important"}
                                                        lineHeight={"20px !important"}
                                                        dangerouslySetInnerHTML={{
                                                            __html: title,
                                                        }}
                                                        color={"#003558 !important"}
                                                        padding={"0px 10px 0 0px"}
                                                        textTransform={"uppercase"}
                                                    />
                                                    <Heading
                                                        mt={"0px"}
                                                        textAlign={"left"}
                                                        fontSize={"14px !important"}
                                                        textTransform={"uppercase"}
                                                        color={"#003558 !important"}
                                                    >
                                                        {closedText && <>CLOSED</>}
                                                    </Heading>

                                                    <Heading
                                                        mt={"0px"}
                                                        textAlign={"left"}
                                                        fontSize={"14px !important"}
                                                        lineHeight={"18px !important"}
                                                        textTransform={"uppercase"}
                                                        color={closedText ? "grey !important" : "#003558 !important"}
                                                        display={"inline-block"}
                                                    >
                                                        <span dangerouslySetInnerHTML={{ __html: dateLabel }} />
                                                    </Heading>
                                                    <Heading
                                                        mt={"0px"}
                                                        textAlign={"left"}
                                                        fontSize={"14px !important"}
                                                        lineHeight={"18px !important"}
                                                        textTransform={"uppercase"}
                                                        color={closedText ? "grey !important" : "#003558 !important"}
                                                        display={"inline-block"}
                                                        whiteSpace={"nowrap"}
                                                    >
                                                        {timeLabel}
                                                    </Heading>
                                                </Box>
                                                <Box>
                                                    <Box>
                                                        <Link
                                                            href={addEvent}
                                                            target="_blank"
                                                            cursor={"pointer"}
                                                            aspectRatio={"1/1"}
                                                            alignItems={"anchor-center"}
                                                            backgroundColor={"#B41E22"}
                                                            borderRadius={"50%"}
                                                            p={"10px"}
                                                            display={"flex"}
                                                            justifyContent={"center"}
                                                            width={"70px"}
                                                            height={"70px"}
                                                        >
                                                            <CalendarIcon fill="#fff" width={"80%"} />
                                                        </Link>
                                                    </Box>
                                                </Box>
                                            </Flex>
                                        </>
                                    ) : (
                                        <>
                                            <Heading
                                                mt={"0px"}
                                                textAlign={"center"}
                                                fontSize={"20px !important"}
                                                lineHeight={"24px!important"}
                                                color={closedText ? "grey !important" : "#003558 !important"}
                                                padding={"0px 20px"}
                                                textTransform={"uppercase"}
                                            >
                                                <span dangerouslySetInnerHTML={{ __html: title }} />
                                            </Heading>

                                            <Heading
                                                mt={"0px"}
                                                textAlign={"center"}
                                                fontSize={"20px !important"}
                                                textTransform={"uppercase"}
                                                color={"#003558 !important"}
                                            >
                                                {closedText && <>CLOSED</>}
                                            </Heading>
                                            <Flex
                                                flexDirection={"column"}
                                                justifyContent={"center"}
                                                alignItems={"center"}
                                                gap={"10px"}
                                                display={closedText ? "none" : "block"}
                                            >
                                                <Box>
                                                    <Link
                                                        href={addEvent}
                                                        target="_blank"
                                                        cursor={"pointer"}
                                                        aspectRatio={"1/1"}
                                                        // alignItems={"flex-start"}
                                                        alignItems={"anchor-center"}
                                                        backgroundColor={"#B41E22"}
                                                        borderRadius={"50%"}
                                                        p={"10px"}
                                                        display={"flex"}
                                                        justifyContent={"center"}
                                                        width={"60px"}
                                                        height={"60px"}
                                                    >
                                                        <CalendarIcon fill={"#fff"} width={"80%"} />
                                                    </Link>
                                                </Box>
                                            </Flex>
                                            <Heading
                                                mt={"0px"}
                                                textAlign={"center"}
                                                fontSize={"20px !important"}
                                                lineHeight={"24px!important"}
                                                textTransform={"uppercase"}
                                                color={closedText ? "grey !important" : "#003558 !important"}
                                            >
                                                <span dangerouslySetInnerHTML={{ __html: dateLabel }} />
                                                <br />
                                                <span class="deadline-time" dangerouslySetInnerHTML={{ __html: timeLabel }} />
                                            </Heading>
                                        </>
                                    )}
                                </Box>
                            )
                        })}
                    </Flex>
                    {descText && (
                        <Text color="white" textAlign="center" mt="30px">
                            {descText}
                        </Text>
                    )}
                </Wrapper>
            </GridItem>
        </Grid>
    )
}
